import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "flex flex-col h-screen justify-between" }
const _hoisted_2 = {
  key: 0,
  class: "bg-white dark:bg-dark-700 shadow-sm"
}
const _hoisted_3 = { class: "max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8" }
const _hoisted_4 = { class: "text-3xl font-bold text-gray-800 dark:text-dark-300" }
const _hoisted_5 = { class: "mb-auto max-w-7xl mx-auto py-6 sm:px-6 lg:px-8" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "px-4 py-6 sm:px-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "border-4 border-dashed border-gray-200 rounded-lg h-96" })
], -1)

import SiteHeader from "@/components/SiteHeader.vue";
import SiteFooter from "@/components/SiteFooter.vue";

interface LayoutDefaultProps {
  title?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutDefault',
  props: {
    title: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SiteHeader),
    (props.title)
      ? (_openBlock(), _createElementBlock("header", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(props.title), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("main", _hoisted_5, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _hoisted_6
      ])
    ]),
    _createVNode(SiteFooter)
  ]))
}
}

})